const currentYear = new Date().getFullYear()

export const SEASONS = [
  { label: String(currentYear - 1), value: String(currentYear - 1) },
  { label: String(currentYear), value: String(currentYear) },
  { label: String(currentYear + 1), value: String(currentYear + 1) },
]
